var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sp-categories-selector",
      style: { width: this.selectWidth + "px" },
    },
    [
      _c(
        "yxt-select",
        {
          ref: "categoriesSelector",
          style: { width: this.selectWidth + "px" },
          attrs: {
            clearable: "",
            size: _vm.size,
            "popper-class": "sp-categories-select__popover",
            placeholder: _vm.$t("pc-biz-sp-categoryse"),
          },
          on: { "visible-change": _vm.openOrCloseSelect, clear: _vm.clear },
          model: {
            value: _vm.classification,
            callback: function ($$v) {
              _vm.classification = $$v
            },
            expression: "classification",
          },
        },
        [
          _c(
            "yxt-option",
            {
              staticClass: "sp-categories-selector__option",
              attrs: { value: null },
            },
            [
              _c("yxt-tree", {
                ref: "categoriesTree",
                staticClass: "sp-tree",
                attrs: {
                  "node-key": "id",
                  "highlight-current": true,
                  data: _vm.categories,
                },
                on: { "node-click": _vm.selected },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }